import { createFileRoute } from "@tanstack/react-router";
import NavbarWebsite from "../components/NavbarWebsite";
import NavbarFooter from "../components/Footer";

export const Route = createFileRoute("/imprint")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <div className="min-h-screen bg-white relative overflow-hidden">
        <NavbarWebsite />

        <div className=" max-w-3xl mx-auto mt-20">
          <p className="text-4xl font-extrabold text-center mb-4 pt-9 ">
            Imprint{" "}
          </p>
          <p className="text-l font-normal text-center mb-4 pb-2">
            Here's the legally required information about the project.
          </p>
        </div>

        {/* Page Title */}
        <main className="relative z-10 max-w-3xl mx-auto text-center">
          {/* Imprint Content Box */}
          <section className="bg-blue-100 rounded-2xl p-8 text-left">
            <h2 className="text-2xl font-semibold text-blue-800 mb-4">
              Information According to § 5 TMG
            </h2>
            <p className="text-gray-900 mb-6 leading-relaxed">
              Max Mustermann
              <br />
              Musterstraße 1<br />
              12345 Musterstadt
              <br />
              Germany
            </p>

            <h2 className="text-xl font-semibold text-blue-800 mb-2">
              Contact
            </h2>
            <p className="text-gray-900 mb-6">
              Telephone: +49 123 456789
              <br />
              Email: info@example.com
            </p>

            <h2 className="text-xl font-semibold text-blue-800 mb-2">
              Responsible for Content According to § 55 Abs. 2 RStV
            </h2>
            <p className="text-gray-900">
              Max Mustermann
              <br />
              Musterstraße 1<br />
              12345 Musterstadt
            </p>
          </section>
        </main>
      </div>
      <NavbarFooter />
    </>
  );
}
